import { Box, styled, Theme, Typography } from '@mui/material';

export const ChatsListMainItem = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    width: '100%',
    minHeight: '80px',
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    padding: '12px 24px',
    borderBottom: '1px solid #D8DBE8',
    cursor: 'pointer',

    [theme.breakpoints.down('tablet')]: {
      padding: '4px 16px',
    },

    '&.selected': {
      backgroundColor: '#F5EFFA',
      pointerEvents: 'none',
      cursor: 'not-allowed',

      [theme.breakpoints.down('laptop')]: {
        backgroundColor: 'transparent',
        cursor: 'pointer',
        pointerEvents: 'initial',
      },
    },
  };
});

export const ChatsListMainItemText = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    display: 'flex',
    flexDirection: 'column',
    width: 'calc(100% - 24px - 20px - 80px)',
  };
});

export const ChatsListMainItemInfo = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    width: '80px',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    justifyContent: 'start',
    gap: '15px',
  };
});

export const ChatsListMainItemInfoTime = styled(Typography)(({ theme }: { theme: Theme }) => {
  return {
    color: '#6F6C7E',
    fontWeight: 400,
    fontSize: '10px',
    lineHeight: '136%',
    textAlign: 'right',
  };
});

export const ChatsListMainItemInfoCountMsgs = styled(Typography)(({ theme }: { theme: Theme }) => {
  return {
    color: '#2B163F',
    fontWeight: 600,
    fontSize: '8px',
    lineHeight: '100%',
    minWidth: '16px',
    width: 'max-content',
    minHeight: '16px',
    height: 'max-content',
    padding: '4px',
    borderRadius: '50%',
    backgroundColor: 'transparent',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    '&.withBackground': {
      backgroundColor: '#D8DBE8',
    },
  };
});

export const ChatsListMainItemTextTitle = styled(Typography)(({ theme }: { theme: Theme }) => {
  return {
    color: '#2B163F',
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '128%',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',

    span: {
      color: '#857F8B',
      fontWeight: 400,
      fontSize: '12px',
      lineHeight: '128%',
    },
  };
});

export const ChatsListMainItemTextLastMsg = styled(Typography)(({ theme }: { theme: Theme }) => {
  return {
    color: '#444444',
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '136%',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  };
});
